<template>
    <div>
        <modal v-model="modalFactura" dir="right" :modalClass="['fill', 'lg right h100']" :title="`Emitir ${typeDTE? this.Util.DTE[typeDTE] : 'Factura Electrónica'}`">
            <div class="section" v-if="modalFactura">
                <input-date
                class="mb15"
                v-model="modalFactura.emisionDate"
                label="Fecha de Emisión"
                type="DATE"
                format="timestamp">
                </input-date>

                <input-select class="mb20"
                label="Actividad Económica"
                :canType="true"
                :fillSearchWithSelected="false"
                v-model="modalFactura.actecos"
                :items="actecos">
                </input-select>

                <label class="mb15">
                    <input type="checkbox" v-model="modalFactura.haceFchVenc">Añadir Fecha de Vencimiento <div class="checkmark"></div>
                </label>

                <input-date
                class="mb15"
                v-if="modalFactura.haceFchVenc"
                v-model="modalFactura.FchVenc"
                label="Fecha de Vencimiento"
                type="DATE"
                format="timestamp">
                </input-date>

                <!-- Indicador Tipo de traslado de bienes -->
                <input-select v-if="typeDTE == 52" 
                class="mb15"
                label="Tipo de Traslado"
                v-model="modalFactura.transferInd"
                :items="[
                    { value: 1, text: 'Operación constituye venta'},
                    { value: 2, text: 'Ventas por efectuar'},
                    { value: 3, text: 'Consignaciones'},
                    { value: 4, text: 'Entrega gratuita'},
                    { value: 5, text: 'Traslados internos'},
                    { value: 6, text: 'Otros traslados no venta'},
                    { value: 7, text: 'Guía de devolución', description: 'Para de devolución de mercaderías que fueron trasladadas para exportación desde la zona de embarque'},
                    { value: 8, text: 'Traslado para exportación. (no venta)', description: 'Envío de mercadería al puerto, aeropuerto o aduana para su exportación. No implica venta.'},
                    { value: 9, text: 'Venta para exportación', description: 'Venta cuya entrega se realiza en Zona Primaria de Aduanas para exportación.'},
                ]">
                </input-select>

                <!-- CdgTraslado -->
                <input-select v-if="typeDTE == 52 && (modalFactura.transferInd == 8 || modalFactura.transferInd == 9)"
                class="mb15"
                label="Código de quien realiza el traslado"
                v-model="modalFactura.transferCode"
                :items="[
                    { value: 1, text: 'Exportador'},
                    { value: 2, text: 'Agente de Aduana', description: 'En la devolución de mercaderías de Aduanas'},
                    { value: 3, text: 'Vendedor', description: 'Entre otros, se refiere a aquel Productor que vende mercadería con entrega en Zona Primaria'},
                    { value: 4, text: 'Contribuyente autorizado expresamente por el SII'}
                ]">
                </input-select>

                <div class="hs mb10 mt15" v-if="typeDTE == 52 && modalFactura.transferCode == 4">
                    <input-field class="mr10"
                    v-model="modalFactura.folioAut"
                    label="Folio de Autorización"
                    type="int+">
                    </input-field>

                    <input-date
                    v-model="modalFactura.dateAut"
                    label="Fecha de Autorización"
                    type="DATE"
                    format="timestamp">
                    </input-date>
                </div>
                
                <div v-if="typeDTE == 52">
                    <div class="separator mb20 mt20"></div>
                    <div class="bold mb15">Transporte</div>

                    <input-field class="mb15"
                    v-if="modalFactura.transferInd == 2 || modalFactura.transferInd == 3"
                    v-model="modalFactura.transport.patent"
                    placeholder="(opcional)"
                    label="Patente">
                    </input-field>

                    <input-field class="mb15"
                    v-if="modalFactura.transferInd == 2 || modalFactura.transferInd == 3"
                    v-model="modalFactura.transport.carrierRut"
                    info="Es el RUT de la empresa o persona responsable del transporte de la carga. Puede ser una empresa de transporte contratada o un transportista independiente."
                    placeholder="(opcional)"
                    label="Rut de Transportista">
                    </input-field>

                    <input-field class="mb15"
                    v-model="modalFactura.transport.driverRut"
                    info="Es el RUT de la persona que conduce el vehículo y realiza físicamente el traslado de la mercadería."
                    placeholder="(opcional)"
                    label="Rut de Chofer">
                    </input-field>

                    <input-field class="mb15"
                    v-model="modalFactura.transport.driverName"
                    info="Es el Nombre de la persona que conduce el vehículo y realiza físicamente el traslado de la mercadería."
                    :placeholder="modalFactura.transport.driverRut? null : `(opcional)`"
                    label="Nombre de Chofer">
                    </input-field>

                    <input-field class="mb15"
                    v-model="modalFactura.transport.destination"
                    placeholder="(opcional)"
                    label="Dirección de Destino">
                    </input-field>

                    <input-field class="mb15"
                    v-model="modalFactura.transport.communeDestination"
                    label="Comuna de Destino">
                    </input-field>
                </div>

                <!-- REFERENCIAS -->
                <div v-if="typeDTE == 61 || typeDTE == 52 || typeDTE == 56 || typeDTE == 33">
                    <div class="separator mb20 mt20"></div>

                    <div class="flex align-center mb10">
                        <div class="bold flex-fill flex" style="font-size: 15px">
                            Referencias
                        </div>

                        <i class="options icon-plus" v-tooltip="'Añadir referencia'" @click="modalFactura.references.push({typeDocument: null, folio_reference: null, emisionDate_reference: null,})"></i>
                    </div>

                    
                    <div class="flex mb10 mt15" v-for="(reference, index) in modalFactura.references" :key="index">
                        <input-select class="mb15"
                        label="Tipo de documento"
                        v-model="reference.typeDocument"
                        canType="search"
                        :items="[
                            { value: 33, text: 'Factura Electrónica' }, 
                            { value: 34, text: 'Factura No Afecta o Exenta Electrónica' },
                            { value: 39, text: 'Boleta Electrónica' },
                            { value: 41, text: 'Boleta Exenta Electrónica' },
                            { value: 46, text: 'Factura de Compra Electrónica' },
                            { value: 52, text: 'Guía de Despacho Electrónica' },
                            { value: 56, text: 'Nota de Débito Electrónica' },
                            { value: 61, text: 'Nota de Crédito Electrónica' },
                            { value: 103, text: 'Liquidación' },
                            { value: 801, text: 'Orden de Compra' },
                            { value: 802, text: 'Nota de Pedido' },
                            { value: 803, text: 'Contrato' },
                            { value: 804, text: 'Resolución' },
                            { value: 805, text: 'Proceso ChileCompra' },
                            { value: 'HES', text: 'HES - Hoja de Entrada de Servicio' }
                        ]">
                        </input-select>

                        <input-field class="ml15 mb15 mr15"
                        v-model="reference.folio_reference"
                        label="Folio Ref.">
                        </input-field>

                        <input-date
                        class="ml15 mb15 mr15"
                        v-model="reference.emisionDate_reference"
                        label="Fecha Ref."
                        type="DATE"
                        format="timestamp">
                        </input-date>

                        <i class="options icon-trash mt30" v-tooltip="'Eliminar referencia'" @click="modalFactura.references.splice(index, 1)"></i>
                    </div>
                </div>

                <!-- RECEPTOR -->
                <div class="separator mb20 mt20"></div>
                <label v-if="typeDTE == 52">
                    <input type="checkbox" v-model="modalFactura.iReceiver">Yo recepciono (Servicio interno) <div class="checkmark"></div>
                </label>
                <label v-if="typeDTE == 39 || typeDTE == 61">
                    <input type="checkbox" v-model="modalFactura.without_receiver">Sin receptor <div class="checkmark"></div>
                </label>
                <div v-if="!modalFactura.without_receiver && !modalFactura.iReceiver" class="flex align-center mb10">
                    <div class="bold flex-fill flex" style="font-size: 15px">
                        Receptor
                    </div>
                        
                    <i class="options icon-trash" v-if="modalFactura.receiver && this.Auth.role != 'cashier'" v-tooltip="'Eliminar receptor'" @click="Confirm({
                        text: 'Eliminar receptor',
                        title: '¿Desea eliminar este receptor?',
                        class: 'selected-color',
                        function: () => { deleteReceiver(modalFactura.receiver, true) }
                    })"></i>

                    <i class="options icon-edit" v-if="modalFactura.receiver" v-tooltip="'Editar receptor'" @click="modalFacturaReceptor = Util.Copy(modalFactura.receiver)"></i>

                    <i class="options icon-plus" v-tooltip="'Añadir receptor'" @click="OpenModalReceiver()"></i>
                </div>

                <div v-if="modalFactura.receiver && !modalFactura.without_receiver && !modalFactura.iReceiver">
                    <input-select class="mb15"
                    v-if="receptorsFactura && !modalFactura.hide_receiver"
                    v-model="modalFactura.receiver"
                    canType="search"
                    :items="receptorsFactura"
                    @OnValueChanged="loadReceiverAddress($event)">
                    </input-select>
                    
                    <input-select class="mb15"
                    v-show="receptorsFactura && modalFactura.receiver && modalFactura.receiver.multi_address.length > 1"
                    v-model="modalFactura.receiver_address"
                    :items="receiverAddresses">
                    </input-select>

                    <div class="mb15" v-if="modalFactura.receiver_address">
                        <!-- <div class="bold">Email</div> -->
                        <div>{{ modalFactura.receiver_address.email }}</div>
                    </div>
                </div>

                <!-- DESCUENTO -->
                <div v-if="typeDTE == 33"> 
                    <div class="separator mb20 mt20"></div>

                    <input-field class="mb15"
                    v-model="modalFactura.discount"
                    label="Descuento"
                    placeholder="$0"
                    prefix="$"
                    type="int+">
                    </input-field>
                </div>

                <div v-if="typeDTE == 33">
                    <div class="separator mb20 mt20"></div>

                    <div class="bold mb10">Método de Pago</div>

                    <input-select class="mb15" 
                    v-model="modalFactura.payment_method"
                    :items="[
                        {text: 'Crédito', value: 2},
                        {text: 'Contado', value: 1},
                        {text: 'Sin costo (Entrega gratuita)', value: 3}
                    ]">
                    </input-select>
                </div>


                <div> <!-- DESCUENTO -->
                    <div class="separator mb20 mt20"></div>

                    <div class="bold mb10">Observaciones</div>

                    <input-text class="mb15"
                    v-model="modalFactura.observations"
                    placeholder="(Opcional)">
                    </input-text>
                </div>

                <div class="separator mb20 mt20"></div>

                <!-- Items -->
                <div>
                    <div class="flex align-center mb20">
                        <div class="f18 flex-fill flex">Items <span class="counter">{{modalFactura.detail.length}}</span></div>
                        <i class="options icon-plus" @click="modalItem = {item: '', quantity: 0, price: 0, total_price: 0, discount: 0, tax: 0, affectIva: true}"></i>
                    </div>
                    <div class="secondary-text mt10 ta-center" v-if="!modalFactura.detail.length">No hay items</div>
                    <div class="flex well selectable mb10" v-for="(entry, index) in modalFactura.detail" :key="index" @click="modalItem=Util.Copy(entry, {index: index, oldItem: entry.item})">
                        <div class="flex-fill">
                            <div class="bold">{{entry.item}}</div>
                            <div class="bold secondary-text mt10 mb10">{{entry.description}}</div>
                            <div class="flex">
                                <div class="w20">
                                    <div class="secondary-text">Cantidad</div>
                                    <div>{{Util.Number(entry.quantity)}}</div>
                                </div>
                                <div class="w20">
                                    <div class="secondary-text">Costo Unitario</div>
                                    <div>{{Util.Price(entry.price)}}</div>

                                    <div class="secondary-text">Subtotal</div>
                                    <div v-if="!entry.total_price">-</div>
                                    <div v-else>{{Util.Price(entry.total_price)}}</div>
                                </div>
                                <div class="w20">
                                    <div class="secondary-text">Impuesto Adicional</div>
                                    <div v-if="!entry.taxAmount">-</div>
                                    <div v-else>{{Util.Price(entry.taxAmount)}}</div>

                                    <div class="secondary-text">IVA</div>
                                    <div v-if="!entry.ivaAmount">-</div>
                                    <div v-else>{{Util.Price(entry.ivaAmount)}}</div>
                                </div>
                                <div class="w20">
                                    <div class="secondary-text">Descuento</div>
                                    <div v-if="!entry.discountAmount">-</div>
                                    <div v-else>{{Util.Price(entry.discountAmount)}}</div>
                                    
                                    <div class="secondary-text">Monto Neto</div>
                                    <div v-if="!entry.netoAmount">-</div>
                                    <div v-else>{{Util.Price(entry.netoAmount)}}</div>
                                </div>
                                <div class="w20">
                                    <div class="secondary-text">Total</div>
                                    <div v-if="!entry.total">-</div>
                                    <div v-else>{{Util.Price(entry.total)}}</div>
                                </div>
                            </div>
                        </div>
                        <i class="options icon-trash" @click.stop="modalFactura.detail.splice(index, 1)"></i>
                    </div>
                </div>
            </div>

            <div class="fill flex align-center" slot="actions">
                <div> {{ Util.Price(totalDte) }} </div>
            </div>

            <button slot="actions" class="primary purple" @click="Confirm({
                title: `Se procederá a enviar la ${Util.DTE[typeDTE]} al SII`,
                text: 'Confirmar',
                class: 'selected-color',
                function: () => {IssueDte(typeDTE)}
            })">Emitir</button>
        </modal>

        <modal v-model="modalItem" dir="right" :modalClass="['fill', 'sm right h100']" :title="modalItem && modalItem.index >= 0 ? 'Editar Item' : 'Agregar Item'">
            <div class="pa20" v-if="modalItem">
                <input-select class="mb15"
                v-model="modalItem.item" 
                :items="inventorySelectItems"
                label="Item"
                canType
                @OnValueChanged="SelectItem($event, modalItem)">
                </input-select>

                <input-field class="mb15"
                v-model="modalItem.description"
                label="Descripción"
                :lines="3"
                placeholder="(Opcional)">
                </input-field>

                <input-field class="mb15"
                v-model="modalItem.quantity"
                type="float+" 
                label="Cantidad"
                :suffix="inventory[modalItem.item] && inventory[modalItem.item].unit ? ' '+inventory[modalItem.item].unit : ''"
                @OnChangeFocused="QuantityChanged($event, modalItem)">
                </input-field>

                <input-field class="mb15"
                v-model="modalItem.price" 
                type="float+" 
                label="Costo Unitario"
                prefix="$"
                @OnChangeFocused="UnitCostChanged($event, modalItem)">
                </input-field>

                <input-field class="mb15"
                v-model="modalItem.total_price" 
                type="float+" 
                label="Subtotal Producto"
                prefix="$"
                @OnChangeFocused="TotalPriceChanged($event, modalItem)">
                    <i class="icon icon-cross selectable" v-tooltip="'Quitar'" 
                    v-show="modalItem.total_price" slot="inner-after"
                    @click="$set(modalItem, 'total_price', null);$set(modalItem, 'price', null)"></i>
                </input-field>

                <input-select class="mb15"
                v-model="modalItem.tax" 
                :items="taxAdditional"
                label="Impuesto Adicional">
                </input-select>

                <input-field class="mb15"
                v-model="modalItem.discount" 
                label="Descuento" 
                type="float" 
                placeholder="(Opcional)"
                :prefix="modalItem.discount < 0 ? '$' : ''"
                :suffix="modalItem.discount > 0 ? '%' : ''"
                info="Un número negativo representa un valor fijo en pesos y un número positivo un porcentaje sobre el costo total del item">
                </input-field>

                <label class="mb10">
                    <input type="checkbox" v-model="modalItem.affectIva"> Afecto de IVA <div class="checkmark"></div>
                </label>

                <div class="mb15" v-if="modalItem.netoAmount">
                    <div class="bold">Monto Neto</div>
                    <div class="bold">{{Util.Price( modalItem.netoAmount )}}</div>
                </div>

                <div class="mb15" v-if="modalItem.ivaAmount">
                    <div class="bold">IVA 19%</div>
                    <div class="bold">{{Util.Price( modalItem.affectIva?  modalItem.ivaAmount  : 0 )}}</div>
                </div>

                <div class="mb15" v-if="itemResumen.total">
                    <div class="bold">Total</div>
                    <div class="bold">{{Util.Price( itemResumen.total )}}</div>
                </div>
            </div>

            <button slot="actions" class="primary purple" @click="AddInventoryItemToInvoice">{{modalItem && modalItem.index >= 0 ? 'Editar' : 'Agregar'}}</button>
        </modal>

        <modal v-model="modalFacturaReceptor" dir="right" :modalClass="['fill', 'md right h100']" :title="modalFacturaReceptor && modalFacturaReceptor.id? 'Editar receptor' : 'Crear receptor'">
            <div class="section" v-if="modalFacturaReceptor">
                <input-field
                inputClass="primary mb15"
                v-model="modalFacturaReceptor.rut"
                placeholder="RUT"
                label="RUT">
                </input-field>

                <input-field
                inputClass="primary mb15"
                v-model="modalFacturaReceptor.name"
                placeholder="Razón Social"
                label="Razón social">
                </input-field>

                <input-field
                inputClass="primary mb15"
                v-model="modalFacturaReceptor.alias"
                placeholder="Alias"
                label="Alias">
                </input-field>

                <input-field
                inputClass="primary mb15"
                v-model="modalFacturaReceptor.line_business"
                placeholder="Giro"
                label="Giro del negocio">
                </input-field>

                <div class="flex align-center mb5">
                    <div class="flex-fill">
                        <div class="bold">Direcciones</div>
                    </div>
                    <div class="f18">
                        <i class="options icon-plus" v-tooltip="'Nueva dirección'" @click="addAddressReceiver()"></i>
                    </div>
                </div>

                <div v-for="(address, index) in modalFacturaReceptor.multi_address" :key="index">
                    <div class="align-center mb10 well">
                        <div class="flex align-center mb5">
                            <div class="flex-fill">
                                <div class="bold">Dirección</div>
                            </div>
                            <div class="f18">
                                <i class="options icon-trash" v-tooltip="'Eliminar dirección'" @click.stop="Confirm({
                                    text: 'Eliminar',
                                    title: '¿Eliminar dirección?',
                                    class: 'error-color',
                                    function: () => {modalFacturaReceptor.multi_address.splice(index, 1)}
                                })"></i>
                            </div>
                        </div>

                        <input-field
                        inputClass="primary mb15"
                        v-model="address.email"
                        placeholder="Email"
                        label="Email">
                        </input-field>

                        <input-field
                        inputClass="primary mb15"
                        v-model="address.address"
                        placeholder="Dirección"
                        label="Dirección">
                        </input-field>

                        <input-field
                        inputClass="primary mb15"
                        v-model="address.commune"
                        placeholder="Comuna"
                        label="Comuna">
                        </input-field>

                        <input-field
                        inputClass="primary mb15"
                        v-model="address.city"
                        placeholder="Ciudad"
                        label="Ciudad">
                        </input-field>
                    </div>
                </div>
            </div>

            <button v-if="modalFacturaReceptor && modalFacturaReceptor.id" slot="actions" class="primary purple" @click="editReceiver()">Editar</button>
            <button v-else slot="actions" class="primary purple" @click="createReceiver()">Crear</button>
        </modal>

        <modal v-model="modalCesion" dir="right" :modalClass="['fill', 'md right h100']" title="Ceder factura electrónica">
            <div class="pa20" v-if="modalCesion">
                <div class="bold mb15">Factura N°{{ modalCesion.folio }} · {{ Util.Price(modalCesion.total) }}</div>

                <div>
                    <input-field class="mb15" v-model="modalCesion.cedente_email" label="Email de la empresa emisora (cedente)" type="email"></input-field>

                    <div class="separator mb20 mt20"></div>
                    <div class="bold mb15">Destinatario de la cesión (cesionario)</div>
                    <div class="secondary-text mb15">Persona o empresa que recibirá el derecho de cobro de esta factura.</div>
                    <input-field class="mb15" v-model="modalCesion.cesionario.RUT" label="RUT"></input-field>
                    <input-field class="mb15" v-model="modalCesion.cesionario.RazonSocial" label="Razón social"></input-field>
                    <input-field class="mb15" v-model="modalCesion.cesionario.Direccion" label="Dirección"></input-field>
                    <input-field class="mb15" v-model="modalCesion.cesionario.email" label="Email del cesionario" type="email"></input-field>

                    <div class="separator mb20 mt20"></div>
                    <input-field class="mb15" v-model="modalCesion.email_deudor" label="Email del receptor de la factura (deudor)" description="Correo del cliente de la empresa emisora que debe pagar esta factura." type="email" placeholder="(Opcional)"></input-field>

                    <div class="separator mb20 mt20"></div>
                    <div class="bold mb15">Datos de la cesión</div>
                    <input-field class="mb15" v-model="modalCesion.monto_cesion" label="Monto de cesión" type="int+" prefix="$" placeholder="Total de la factura (opcional)"></input-field>
                    <label class="mb15">
                        <input type="checkbox" v-model="modalCesion.conVencimiento"> Añadir último vencimiento <div class="checkmark"></div>
                    </label>
                    <input-date v-if="modalCesion.conVencimiento" class="mb15" v-model="modalCesion.due_date" label="Último vencimiento" type="DATE" format="YYYY-MM-DD"></input-date>
                </div>
            </div>

            <button slot="actions" class="primary purple" @click="CederFactura()">Ceder factura</button>
        </modal>

        <modal v-model="modalSendCesion" dir="center" modalClass="sm" title="Enviar cesión de factura">
            <div class="pa20" v-if="modalSendCesion">
                <div class="bold mb15">Factura N°{{ modalSendCesion.folio }}</div>
                <div class="secondary-text mb15" v-if="modalSendCesion.track_id">Track ID: {{ modalSendCesion.track_id }}</div>
                <input-field class="mb20" v-model="modalSendCesion.email" label="Email" type="email">
                    <button slot="after" class="primary purple" @click="SendCesionEmail()">Enviar</button>
                </input-field>
            </div>
            <button v-if="modalSendCesion && modalSendCesion.idCesion" slot="actions" class="secondary" @click="DownloadCesion(false)">Abrir XML</button>
            <button v-if="modalSendCesion && modalSendCesion.idCesion" slot="actions" class="secondary" @click="DownloadCesion()">Descargar XML</button>
        </modal>

        <modal v-model="modalSendDte" dir="center" modalClass="sm" :title="`Enviar ${modalSendDte ? Util.DTE[modalSendDte.type] : 'Factura'}`">
            <i slot="options" v-if="modalSendDte && modalSendDte.type == 33" class="options icon-dots-vertical" @click="Options([{text: 'Imprimir', function: () => {PrintFactura(modalSendDte.printData)}}])"></i>
            <div class="pa20" v-if="modalSendDte">
                <input-field class="mb20"
                v-model="modalSendDte.email"
                label="Email">
                    <button slot="after" class="primary purple" @click="SendFacturaEmail()">Enviar</button>
                </input-field>
            </div>

	        <button slot="actions" class="secondary" @click="DownloadDte(0)">{{ modalSendDte && modalSendDte.recieved? 'Descargar' : (modalSendDte && modalSendDte.type != 33? 'Abrir' : 'Descargar Tributaria')}}</button>
	        <button v-if="modalSendDte && modalSendDte.type == 33 && !modalSendDte.recieved" slot="actions" class="secondary" @click="DownloadDte(1)">Descargar Cedible</button>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            default: null,
        }
    },
    data(){
        return {
            modalFactura: null,
            modalItem: null,
            modalFacturaReceptor: null,
            modalSendDte: null,
            modalCesion: null,
            modalSendCesion: null,
            receptorsFactura: null,
            receiverAddresses: [],
            actecos: [],
            inventory: {},
            taxAdditionalSII: {},
            typeDTE: 33,
        }
    },
    methods: {
        Open(type = 33, receiver){
            this.typeDTE = type;
            this.getReceivers(receiver);
        },
        OpenModalReceiver(receiver){
            if(receiver) return this.modalFacturaReceptor = receiver;
            return this.modalFacturaReceptor = { multi_address : [{ address: '', city: '', commune: '' }] };
        },
        getReceivers(receiver){
            this.Loading();

            axios.post(`/sii/receivers/${this.Local.id}`)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
                this.modalFactura = { detail: [], receiver: data.receivers[0], detailsItems: {} , discount: 0 , transport: {}, references: []};
                this.inventory = data.items;
                this.taxAdditionalSII = data.tax_additional;
                this.loadReceptorData(data.receivers, receiver);
                this.loadActecosData(data.actecos);
                if(this.order) this.importInventory(this.order.orders);
                
                if(data.actecos) this.$set(
                    this.modalFactura,
                    'actecos',
                    data.actecos[0].split('-')[0].trim()
                );

                this.Response(data);
                setTimeout(() => {
                    if (receiver){
                        this.modalFactura.receiver = receiver;
                        this.loadReceiverAddress(receiver);
                        this.modalFactura.hide_receiver = true;
                    }
                }, 0);
            })
            .catch( err => {
                this.Response(err);
            })
        },
        createReceiver(){
            const rutRegex = /^\d{1,2}\.\d{3}\.\d{3}[-][0-9kK]{1}$/;

            if(!this.modalFacturaReceptor.rut) return this.Info('RUT es obligatorio');
            if(!this.modalFacturaReceptor.name) return this.Info('Razón social es obligatorio');
            if(!this.modalFacturaReceptor.line_business) return this.Info('Giro es obligatorio');

            if(!this.modalFacturaReceptor.rut.includes('-')) this.modalFacturaReceptor.rut = Util.Rut(this.modalFacturaReceptor.rut);
            if(!rutRegex.test(this.modalFacturaReceptor.rut)) return this.Info('Rut inválido');

            let error = null;
            this.modalFacturaReceptor.multi_address.forEach( data => {
                // if(!data.email || data.email == '') return error = 'El email es obligatorio';
                if(!data.address || data.address == '') return error = 'La dirección es obligatoria';
                if(!data.commune || data.commune == '') return error = 'La comuna es obligatoria';
                if(!data.city || data.city == '') return error = 'La ciudad es obligatoria';
            });
            if(error) return this.Info(error);

            this.Loading();
            axios.post(`/sii/receiver/${this.Local.id}/create`, this.modalFacturaReceptor)
            .then( ({data}) => {
                if(data.status){
                    if(this.modalFactura) this.$set(this.modalFactura, 'receiver', data.receiver);
                    this.loadReceptorData(data.receivers);
                    this.modalFacturaReceptor = null;
                    this.$emit('reloadReceiver');
                }

                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
                if(err.response.data.message) this.Info(err.response.data.message);
            });
        },
        editReceiver(){
            this.Loading();
            if(!this.modalFacturaReceptor.rut) return this.Info('RUT es obligatorio');
            if(!this.modalFacturaReceptor.name) return this.Info('Razón social es obligatorio');
            if(!this.modalFacturaReceptor.line_business) return this.Info('Giro es obligatorio');

            let error = null;
            this.modalFacturaReceptor.multi_address.forEach( data => {
                // if(!data.email || data.email == '') return error = 'El email es obligatorio';
                if(!data.address || data.address == '') return error = 'La dirección es obligatoria';
                if(!data.commune || data.commune == '') return error = 'La comuna es obligatoria';
                if(!data.city || data.city == '') return error = 'La ciudad es obligatoria';
            });
            if(error) return this.Info(error);

            axios.post(`/sii/receiver/${this.Local.id}/edit`, this.modalFacturaReceptor)
            .then( ({data}) => {
                if(data.status){
                    if(this.modalFactura) this.$set(this.modalFactura, 'receiver', data.receiver);
                    this.loadReceptorData(data.receivers);
                    this.loadReceiverAddress(data.receiver);
                    this.modalFacturaReceptor = null;
                    this.$emit('reloadReceiver');
                }

                this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
                if(err.response.data.message) this.Info(err.response.data.message);
            });
        },
        deleteReceiver(receiver, modal){
            this.Loading();
            axios.post(`/sii/receiver/${this.Local.id}/delete`, receiver)
            .then( ({data}) => {

                if(data.status){
                    if(modal) this.getReceivers();
                    this.$emit('reloadReceiver');
                } 

                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        loadReceptorData(receivers){
            this.receptorsFactura = [];

            receivers.forEach(receiver => {
                this.receptorsFactura.push(
                    {text: `${receiver.rut} ${receiver.name} ${receiver.alias? '('+receiver.alias+')' : ''}`, value: receiver}
                );
            });
        },
        loadReceiverAddress(receiver){
            this.receiverAddresses = [];
            receiver.multi_address.forEach( address => {
                this.receiverAddresses.push(
                    {text: `${address.address}, ${address.commune}, ${address.city}`, value: address}
                );
            });
        },
        loadActecosData(actecos){
            if(!actecos) return;
            this.actecos = [];

            actecos.forEach( acteco => {
                this.actecos.push(
                    {text: acteco, value: acteco.split('-')[0].trim() }
                );
            });
        },
        AddInventoryItemToInvoice(){
            if(!this.modalItem.item) return this.Info('Item inválido');
            if(this.modalItem.item.length >= 80) return this.Info('El nombre del ítem excede el límite de 80 caracteres'); 
            if(this.modalItem.quantity <= 0) return this.Info('Cantidad inválida');
            if(this.modalItem.price <= 0) return this.Info('Precio inválido');

            var index = this.modalItem.index;
            delete this.modalItem[index];

            isNaN(index)? this.modalFactura.detail.push(this.modalItem) : this.$set(this.modalFactura.detail, index, this.modalItem);
            this.modalItem = null;
        },
        QuantityChanged(quantity, modal){
            quantity = parseFloat(quantity);
            if(isNaN(quantity) || quantity == 0) return;

            let unitCost = parseFloat(modal['price']);

            if(!isNaN(unitCost)){
                this.$set(modal, 'total_price', unitCost*quantity);
                return;
            }

            let totalCost = parseFloat(modal['total_price']);
            if(!isNaN(totalCost))
            {
                this.$set(modal, 'price', totalCost / quantity);
                return;
            }

            /* if(!this.modalItem) return;
            if(isNaN(this.modalItem.quantity)) return this.$set(this.modalItem, 'quantity', '');
            let price = (!this.modalItem.price || isNaN(this.modalItem.price))? 0 : this.modalItem.price;
            this.$set(this.modalItem, 'total_price', price*val); */
        },
        UnitCostChanged(unitCost, modal){
            var quantity = parseFloat(modal['quantity']);
            if(isNaN(quantity)) return;
            unitCost = parseFloat(unitCost);
            if(isNaN(unitCost)) return this.$set(modal, 'total_price', '');
            this.$set(modal, 'total_price', unitCost * quantity);

            /* if(!this.modalItem || this.modalItem.quantity <= 0) return;
            if(isNaN(this.modalItem.quantity)) return this.$set(this.modalItem, 'total_price', '');
            this.$set(this.modalItem, 'total_price', parseFloat((val*this.modalItem.quantity).toFixed(2)) ); */
        },
        TotalPriceChanged(totalPrice, modal){
            var quantity = parseFloat(modal['quantity']);
            if(isNaN(quantity) || quantity == 0) return;
            totalPrice = parseFloat(totalPrice);
            if(isNaN(totalPrice)) return this.$set(modal, 'price', '');
            this.$set(modal, 'price', totalPrice / quantity);

            /* if(!this.modalItem || this.modalItem.quantity <= 0) return;
            if(isNaN(this.modalItem.quantity)) return this.$set(this.modalItem, 'price', '');
            var cost = val / this.modalItem.quantity ;
            this.$set(this.modalItem, 'price', parseFloat(cost.toFixed(2))); */
        },
        IssueDte(typeDocument){
            if (this.modalFactura.references && this.modalFactura.references.length > 0) {
                const invalidRef = this.modalFactura.references.find(ref => !ref.folio_reference || ref.folio_reference === '');
                if (invalidRef) {
                    return this.Info('Todas las referencias deben tener un folio válido.');
                }
            }

            switch (typeDocument) {
                case 33:
                    this.generateFacturaElectronica();
                    break;
                case 52:
                    this.IssueDispatchGuide();
                    break;
                case 56:
                    this.generateNotaDebito();
                    break;
                case 61:
                    this.generateNotaCredito();
                    break;
                default:
                    break;
            }
        },
        generateFacturaElectronica(factura = null){
            const actecosRegex = /^\d{6}( - .+)?$/;

            let facturaData = factura? factura: this.modalFactura;

            if(!facturaData.actecos) return this.Info('La actividad económica es obligatoria');
            if(!actecosRegex.test(facturaData.actecos)) return this.Info('La actividad económica es inválida');
            if(!facturaData.receiver) return this.Info('El receptor es obligatorio');
            if(!factura && !facturaData.detail.length) return this.Info('La factura debe contener ítems');

            let details = this.calculateInvoiceDetail();
            let acteco = facturaData.actecos.split(' - ')[0];

            if(!factura) this.$set(facturaData, 'detailsItems', details);
            this.$set(facturaData, 'actecos', acteco);
            if(this.order) this.$set(facturaData, 'order_id', this.order.id);

            this.$set(facturaData.receiver, 'address', facturaData.receiver_address.address);
            this.$set(facturaData.receiver, 'city', facturaData.receiver_address.city);
            this.$set(facturaData.receiver, 'commune', facturaData.receiver_address.commune);
            this.$set(facturaData.receiver, 'email', facturaData.receiver_address.email);

            this.Loading();
            axios.post(`/sii/factura/${this.Local.id}/create`, facturaData)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
                this.$emit("generateDte", data.transaction);
                facturaData = null;
                this.OpenmodalSendDte(data.factura);
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        generateNotaCredito(){
            const actecosRegex = /^\d{6}( - .+)?$/;
            if(!this.modalFactura.actecos) return this.Info('La actividad económica es obligatoria');
            if(!actecosRegex.test(this.modalFactura.actecos)) return this.Info('La actividad económica es inválida');
            if(!this.modalFactura.detail.length) return this.Info(`La ${this.typeDTE == 33? 'factura' : 'nota de crédito'} debe contener ítems`);
            if(!this.modalFactura.without_receiver && !this.modalFactura.receiver) return this.Info('El receptor es obligatorio');
            if(!this.modalFactura.references.length) return this.Info(`Debe tener al menos una referencia`);

            this.Loading();

            let details = this.calculateInvoiceDetail();
            let acteco = this.modalFactura.actecos.split(' - ')[0];

            this.$set(this.modalFactura, 'detailsItems', details);
            this.$set(this.modalFactura, 'actecos', acteco);
            if(this.order) this.$set(this.modalFactura, 'order_id', this.order.id);
            if(this.modalFactura.without_receiver) this.$set(this.modalFactura, 'receiver', null);

            if(this.modalFactura.receiver){
                this.$set(this.modalFactura.receiver, 'address', this.modalFactura.receiver_address.address);
                this.$set(this.modalFactura.receiver, 'city', this.modalFactura.receiver_address.city);
                this.$set(this.modalFactura.receiver, 'commune', this.modalFactura.receiver_address.commune);
                this.$set(this.modalFactura.receiver, 'email', this.modalFactura.receiver_address.email);
            }

            axios.post(`/sii/nota-credito/${this.Local.id}/create`, this.modalFactura)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
                this.$emit("generateDte", data.transaction);
                this.modalFactura = null;
                this.OpenmodalSendDte(data.nota_credito, data.nota_credito.type);
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        generateNotaDebito(){
            const actecosRegex = /^\d{6}( - .+)?$/;
            if(!this.modalFactura.actecos) return this.Info('La actividad económica es obligatoria');
            if(!actecosRegex.test(this.modalFactura.actecos)) return this.Info('La actividad económica es inválida');
            if(!this.modalFactura.detail.length) return this.Info(`La ${this.typeDTE == 33? 'factura' : 'nota de crédito'} debe contener ítems`);
            if(!this.modalFactura.receiver) return this.Info('El receptor es obligatorio');
            if(!this.modalFactura.references.length) return this.Info(`Debe tener al menos una referencia`);

            this.Loading();

            let details = this.calculateInvoiceDetail();
            let acteco = this.modalFactura.actecos.split(' - ')[0];

            this.$set(this.modalFactura, 'detailsItems', details);
            this.$set(this.modalFactura, 'actecos', acteco);
            if(this.order) this.$set(this.modalFactura, 'order_id', this.order.id);
            if(this.modalFactura.without_receiver) this.$set(this.modalFactura, 'receiver', null);

            if(this.modalFactura.receiver){
                this.$set(this.modalFactura.receiver, 'address', this.modalFactura.receiver_address.address);
                this.$set(this.modalFactura.receiver, 'city', this.modalFactura.receiver_address.city);
                this.$set(this.modalFactura.receiver, 'commune', this.modalFactura.receiver_address.commune);
                this.$set(this.modalFactura.receiver, 'email', this.modalFactura.receiver_address.email);
            }

            axios.post(`/sii/nota-debito/${this.Local.id}/create`, this.modalFactura)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
                this.$emit("generateDte", data.transaction);
                this.modalFactura = null;
                this.OpenmodalSendDte(data.nota_debito, data.nota_debito.type);
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        IssueDispatchGuide(){
            const actecosRegex = /^\d{6}( - .+)?$/;
            if(!this.modalFactura.actecos) return this.Info('La actividad económica es obligatoria');
            if(!actecosRegex.test(this.modalFactura.actecos)) return this.Info('La actividad económica es inválida');
            if(!this.modalFactura.detail.length) return this.Info(`La Guía de despacho debe contener ítems`);
            if(this.modalFactura.transport && !this.modalFactura.transport.communeDestination) return this.Info(`La comuna de destino es obligatoria`);
            this.Loading();

            let details = this.calculateInvoiceDetail();
            let acteco = this.modalFactura.actecos.split(' - ')[0];

            this.$set(this.modalFactura, 'detailsItems', details);
            this.$set(this.modalFactura, 'actecos', acteco);
            if(this.order) this.$set(this.modalFactura, 'order_id', this.order.id);
            if(this.modalFactura.without_receiver) this.$set(this.modalFactura, 'receiver', null);

            if(this.modalFactura.receiver){
                this.$set(this.modalFactura.receiver, 'address', this.modalFactura.receiver_address.address);
                this.$set(this.modalFactura.receiver, 'city', this.modalFactura.receiver_address.city);
                this.$set(this.modalFactura.receiver, 'commune', this.modalFactura.receiver_address.commune);
                this.$set(this.modalFactura.receiver, 'email', this.modalFactura.receiver_address.email);
            }

            axios.post(`/sii/dispatch_guide/${this.Local.id}/issue`, this.modalFactura)
            .then( ({data}) => {
                if(!data.status) return this.Info(data.message);
                this.$emit("generateDte");
                this.modalFactura = null;
                this.OpenmodalSendDte(data.dispatch_guide, data.dispatch_guide.type);
                return this.Info(data.message);
            })
            .catch( err => {
                this.Response(err);
            });
        },
        calculateInvoiceDetail(){
            if(!this.modalFactura) return;
            if(!this.modalFactura.detail.length) return;

            let items = [];
            let mntNeto = 0;
            let taxes = 0;
            let discount = 0;
            let iva = 0;

            for(let i = 0; i < this.modalFactura.detail.length; i++){
                let item = this.modalFactura.detail[i];
                if(item.quantity <= 0 || item.price <= 0) return;
                let itemQuantity = item.quantity;
                let itemPrice = item.price;
                let itemDescription = item.description;
                let itemTotal = item.quantity * item.price;

                //DESCUENTO
                let itemDiscount = 0;
                let itemDiscountPercentage = isNaN(item.discount) ? 0 : item.discount;
                if(itemDiscountPercentage >= 0){
                    itemDiscount = (itemDiscountPercentage / 100) * itemTotal;
                }else{
                    itemDiscount = -itemDiscountPercentage;
                    itemDiscountPercentage = (itemDiscount * 100) / itemTotal;
                }
                discount += itemDiscount;

                let itemNeto = itemTotal - itemDiscount;
                mntNeto += itemNeto;

                //IMPUESTO ADICIONAL
                let itemTax = 0;
                let itemTaxCode = item.tax? item.tax.toString().split("-")[0] : null;
                let itemTaxPercentage = item.tax? item.tax.toString().split("-")[1] : 0;
                itemTax = Math.round((itemTaxPercentage / 100) * itemNeto);
                taxes += itemTax;

                let ivaItem = item.affectIva ? Math.round(itemNeto * 0.19) : 0;

                let entryTotal =  itemNeto + itemTax + ivaItem;

                iva += ivaItem;
                if(entryTotal < 0) return null;
                items.push({
                    item: item.item,
                    quantity: itemQuantity,
                    price: itemPrice,
                    description: itemDescription,
                    tax: itemTax,
                    taxPercentage: itemTaxPercentage,
                    taxCode: itemTaxCode,
                    discount: itemDiscount,
                    discountPercentage: itemDiscountPercentage,
                    mntNeto: itemNeto,
                    iva: ivaItem,
                    affection: item.affectIva,
                    total: entryTotal,
                    unitCost: this.Util.RoundFloat(entryTotal / itemQuantity),
                    unit: this.modalFactura.detail[item.item] && this.modalFactura.detail[item.item].unit ? this.modalFactura.detail[item.item].unit : null
                });
            }
            
            return {
                items: items,
                total: {
                    mntNeto,
                    iva,
                    taxes,
                    discount,
                    total: mntNeto + taxes + iva
                },
            };
        },
        importInventory(orders){
            orders.forEach( item => {
                if(item.price >= 0){ //ítems normales
                    this.modalItem = {};
                    let unidadXitem = item.total_money / 1.19;
                    this.$set(this.modalItem, 'item', item.title);
                    this.$set(this.modalItem, 'description', item.comment);
                    this.$set(this.modalItem, 'quantity', item.quantity);
                    this.$set(this.modalItem, 'price', unidadXitem/item.quantity);
                    this.$set(this.modalItem, 'total_price', unidadXitem);
                    this.$set(this.modalItem, 'ivaAmount', unidadXitem*0.19);
                    this.$set(this.modalItem, 'netoAmount', unidadXitem);
                    this.$set(this.modalItem, 'affectIva', true);
                    this.$set(this.modalItem, 'total', item.total_money);
                    this.AddInventoryItemToInvoice();
                    this.modalItem = null;
                }else{ //cupones o descuentos
                    if(this.modalFactura) this.modalFactura.discount += -item.price;
                }
                
            });
        },
        OpenmodalSendDte(data, type = 33){
            const types = {
                33: 'factura',
                61: 'nota_credito'
            };
            const dteType = types[type];
            //Data proveniente de transacción 
            let idDte = null;
            let folio = null;
            let total = null;
            let rutReceiver = null;
            let date = null;
            let email = null;
            let printData = null;
            if(data.custom_data){
                let dteData = data.custom_data[dteType];
                idDte = data['id_'+dteType];
                folio = dteData.folio;
                total = parseInt(dteData.total.replace(".", ""));
                rutReceiver = dteData.receptor && dteData.receptor.RUTRecep? dteData.receptor.RUTRecep : (dteData.rutReceptor? dteData.rutReceptor.replace(/\./g,'') : '');
                date = dteData.fecha_corta;
                email = dteData.receptor && dteData.receptor.CorreoRecep? dteData.receptor.CorreoRecep : '';
                printData = dteData;
            //Data proveniente de factura 
            }else{
                idDte = data.id;
                folio = data.folio;
                total = data.total;
                rutReceiver = data.rut_receiver;
                date = data.date;
                email = data.print_data.receptor && data.print_data.receptor.CorreoRecep? data.print_data.receptor.CorreoRecep : '';
                printData = data.print_data;
            }

            this.modalSendDte = {idDte, folio, total, rutReceiver, date, email, type, printData, recieved: data.recieved};
        },
        OpenModalCesion(factura){
            if(factura.recieved || factura.type != 33 || factura.status != 'OK') return this.Info('Esta factura no se puede ceder.');

            const printData = factura.print_data || {};
            this.modalCesion = {
                idFactura: factura.id,
                folio: factura.folio,
                total: factura.total,
                cesionario: {RUT: '', RazonSocial: '', Direccion: '', email: ''},
                cedente_email: printData.emisor && printData.emisor.CorreoEmisor || '',
                monto_cesion: null,
                conVencimiento: false,
                due_date: null,
                email_deudor: printData.receptor && printData.receptor.CorreoRecep || '',
            };
        },
        OpenModalReenviarCesion(factura){
            if(!factura.id_cesion) return this.Info('La factura no tiene una cesión generada.');

            this.modalSendCesion = {
                idCesion: factura.id_cesion,
                folio: factura.folio,
                email: '',
            };
        },
        CederFactura(){
            if(!this.modalCesion) return;

            const cesion = this.modalCesion;
            const cesionario = {
                RUT: cesion.cesionario.RUT.trim(),
                RazonSocial: cesion.cesionario.RazonSocial.trim(),
                Direccion: cesion.cesionario.Direccion.trim(),
                email: cesion.cesionario.email.trim(),
            };
            const cedenteEmail = cesion.cedente_email.trim();
            const emailDeudor = cesion.email_deudor.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const monto = cesion.monto_cesion === null || cesion.monto_cesion === '' ? null : Number(cesion.monto_cesion);

            if(!cesionario.RUT) return this.Info('El RUT del cesionario es obligatorio.');
            if(!cesionario.RazonSocial || cesionario.RazonSocial.length > 100) return this.Info('La razón social es obligatoria y debe tener hasta 100 caracteres.');
            if(cesionario.Direccion.length < 5 || cesionario.Direccion.length > 80) return this.Info('La dirección debe tener entre 5 y 80 caracteres.');
            if(!emailRegex.test(cesionario.email) || cesionario.email.length < 6 || cesionario.email.length > 80) return this.Info('Email del cesionario inválido.');
            if(!emailRegex.test(cedenteEmail) || cedenteEmail.length < 6 || cedenteEmail.length > 80) return this.Info('Email de la empresa emisora (cedente) inválido.');
            if(emailDeudor && (!emailRegex.test(emailDeudor) || emailDeudor.length > 80)) return this.Info('Email del receptor de la factura (deudor) inválido.');
            if(monto !== null && (!Number.isInteger(monto) || monto < 1 || monto > Number(cesion.total))) return this.Info('El monto debe ser un entero mayor a cero y no superar el total de la factura.');

            const payload = {
                idFactura: cesion.idFactura,
                cesionario,
                cedente_email: cedenteEmail,
                monto_cesion: monto,
                due_date: cesion.conVencimiento ? cesion.due_date : null,
                email_deudor: emailDeudor || null,
            };

            this.Confirm({
                title: `¿Ceder la factura N°${cesion.folio} a ${cesionario.RazonSocial} por ${this.Util.Price(monto === null ? cesion.total : monto)} y enviarla al SII?`,
                text: 'Ceder factura',
                class: 'selected-color',
                function: () => {
                    if(this.modalCesion !== cesion) return;
                    this.Loading();
                    return axios.post(`/sii/factura/${this.Local.id}/cesion`, payload).then(({data}) => {
                        if(!data.status) return this.Info(data.message);
                        this.modalCesion = null;
                        this.$emit('generateDte');
                        if(!data.email_sent){
                            this.modalSendCesion = {...data, folio: cesion.folio, email: cesionario.email};
                            return this.Info(data.email_error || 'La cesión se generó, pero no se pudo enviar por correo. Puedes reintentarlo.');
                        }
                        this.Info(`${data.message} XML enviado a ${cesionario.email}.`);
                    }).catch(err => {
                        const data = err.response && err.response.data;
                        if(data && data.idCesion) {
                            this.modalCesion = null;
                            this.$emit('generateDte');
                            if(!data.email_sent) this.modalSendCesion = {...data, folio: cesion.folio, email: cesionario.email};
                            this.Info(data.message);
                        } else {
                            this.Response(err);
                        }
                    });
                },
            });
        },
        async DownloadCesion(download = true){
            const data = this.modalSendCesion;
            if(!data || !data.idCesion) return;

            const tab = download ? null : window.open('', '_blank');
            if(!download && !tab) return this.Info('Permite las ventanas emergentes para abrir el XML.');
            if(tab) tab.opener = null;

            this.Loading();
            try {
                const response = await axios.get(`/sii/factura/${this.Local.id}/cesion/${data.idCesion}/xml`, {
                    params: {download: download ? 1 : 0},
                    responseType: 'blob',
                });
                if(download) {
                    this.Util.DownloadFile(response, `AEC_${data.idCesion}.xml`);
                } else {
                    const url = window.URL.createObjectURL(response.data);
                    tab.location.replace(url);
                    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
                }
                this.Response({error: false});
            } catch(err) {
                if(tab) tab.close();
                if(err.response && err.response.data instanceof Blob) {
                    err.response.data = JSON.parse(await err.response.data.text());
                }
                this.Response(err);
            }
        },
        SendCesionEmail(){
            if(!this.modalSendCesion) return;
            const email = this.modalSendCesion.email.trim();
            if(!email) return this.Info('El campo email es obligatorio.');
            this.Loading();
            return axios.post(`/sii/factura/${this.Local.id}/cesion/send`, {
                idCesion: this.modalSendCesion.idCesion,
                email,
            }).then(({data}) => {
                if(!data.status) return this.Info(data.message);
                this.modalSendCesion = null;
                this.Info(data.message);
            }).catch(err => {
                this.Response(err);
            });
        },
        SendFacturaEmail(){
            if(!this.modalSendDte.email || this.modalSendDte.email == "") return this.Info('El campo email es obligatorio.');
            this.Loading();
			axios.post(`/sii/dte/send`, this.modalSendDte).then( ({data}) => {
                this.Info(`${this.Util.DTE[this.modalSendDte.type]} enviada a ${this.modalSendDte.email}`);
                return this.modalSendDte = null;
			}).catch(err => {
				this.Response(err);
			});
        },
        DownloadDte(cedible){
            let dataDte = this.modalSendDte;
            Util.Open(`${this.Util.backend}admin/sii/dte/${dataDte.folio}/${dataDte.type}/${dataDte.total}/${dataDte.rutReceiver}/navigator/pdf/${cedible}/${dataDte.recieved}`)
        },
        SelectItem(title, modal){
            let item = this.inventory.filter(function(obj) {
                return obj.title === title;
            })[0];
            
            if(!item || modal.oldItem == title) return;
            
            this.$set(this.modalItem, 'price', item.price/1.19);
        },
        addAddressReceiver(){
            if (!this.modalFacturaReceptor.multi_address) this.$set(this.modalFacturaReceptor, 'multi_address', []);

            this.modalFacturaReceptor.multi_address.push({ address: '', city: '', commune: '' });
        },
        PrintFactura(facturaData) {
            this.Util.NotifyService('factura', {data: facturaData, id: Math.random().toString()});
        }
    },
    computed: {
        inventorySelectItems() {
            var ret = [];
            for(var key in this.inventory)
            {
                var item = this.inventory[key];
                ret.push({
                    text: item.title + (item.unit ? ` (${item.unit})` : ''),
                    value: item.title
                });
            }
            return this.Util.NaturalSort(ret, 'text');
        },
        taxAdditional(){
            var ret = [];
            for(var key in this.taxAdditionalSII)
            {
                var item = this.taxAdditionalSII[key];
                ret.push({
                    text: `${item.name} ${item.tax_percentage}%`,
                    value: `${item.code}-${item.tax_percentage}`
                });
            }
            return this.Util.NaturalSort(ret, 'code');
        },
        itemResumen() {
            if(!this.modalItem) return {};
            if(!this.modalItem.total_price || isNaN(this.modalItem.total_price) || this.modalItem.total_price == 0) return {};
            let totalProduct = this.modalItem.total_price;

            let discountAmount = isNaN(this.modalItem.discount)? 0 : this.modalItem.discount;
            discountAmount = discountAmount >= 0? (discountAmount / 100) * totalProduct : -discountAmount;

            let netoAmount = totalProduct - discountAmount;

            let taxAmount = this.modalItem.tax? this.modalItem.tax.toString().split("-")[1] : 0;
            taxAmount = Math.round((taxAmount / 100) * (netoAmount));

            let ivaAmount = this.modalItem.affectIva? Math.round(netoAmount * 0.19) : 0;
            let total = ivaAmount + netoAmount + taxAmount;

            this.$set(this.modalItem, 'netoAmount', netoAmount);
            this.$set(this.modalItem, 'discountAmount', discountAmount);
            this.$set(this.modalItem, 'taxAmount', taxAmount);
            this.$set(this.modalItem, 'ivaAmount', ivaAmount);
            this.$set(this.modalItem, 'total', total);

            return {
                netoAmount,
                ivaAmount,
                total
            };
        },
        totalDte() {
            if(!this.modalFactura || !this.modalFactura.detail) return 0;
            let total = this.modalFactura.detail.reduce((accumulator, currentItem) => accumulator + currentItem.total, 0);
            if(!this.modalFactura.discount) return total;
            let totalWithDiscount = total - this.modalFactura.discount;
            return totalWithDiscount;
        }
    }
}
</script>
